import $http from "../axios";

const state = {
  feedbacks: []
};

const getters = {
  feedbacks: state => {
    return state.feedbacks;
  }
};

const actions = {
  getFeedbacks({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          `feedbacks?storeId=${data.storeId}&beginDate=${
            data.dates[0]
          }&endDate=${data.dates[1]}`
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_FEEDBACKS", res.data.payload.feedbacks);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  changeFeedbackStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`change-feedback-status`, data)
        .then(res => {
          commit("CHANGE_FEEDBACK_STATUS", data);
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_FEEDBACKS(state, feedbacks) {
    state.feedbacks = feedbacks;
  },
  CHANGE_FEEDBACK_STATUS(state, payload) {
    state.feedbacks = JSON.parse(
      JSON.stringify(
        state.feedbacks.map(f => {
          if (f._id === payload.feedbackId) {
            f.status = payload.status;
          }
          return f;
        })
      )
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
